import * as React from 'react';
import { connect } from 'react-redux';
import Login from './Login';

const Home = () => (
    <React.Fragment>
        <Login />
    </React.Fragment>
);

export default connect()(Home);
